import apiRequestType from "../../apiRequestType";
import { apiTypes } from "../../../utils/apiTypes";
import { apiConstants } from "../../../utils/apiConstants";

const rejectShotClass = (classId) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.SOCIAL.MODERATE_CONTRIBUTIONS.REJECT_SHOTCLASS(classId)
  );
};

export default rejectShotClass;
